<template>
  <svg width="36" height="33" viewBox="0 0 36 33" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
    <path
      d="M16.86 14.8409C20.4278 14.8409 23.32 12.1897 23.32 8.91922C23.32 5.64878 20.4278 2.99756 16.86 2.99756C13.2922 2.99756 10.4 5.64878 10.4 8.91922C10.4 12.1897 13.2922 14.8409 16.86 14.8409Z"
      fill="black"
      :class="containerClass"
    />
    <path d="M21 25.6666H28V26.95H21V25.6666Z" fill="black" :class="containerClass" />
    <path
      d="M15 27.5V30.25C15 30.4931 15.1054 30.7262 15.2929 30.8982C15.4804 31.0701 15.7348 31.1666 16 31.1666H33C33.2652 31.1666 33.5196 31.0701 33.7071 30.8982C33.8946 30.7262 34 30.4931 34 30.25V21.0833C34 20.8402 33.8946 20.607 33.7071 20.4351C33.5196 20.2632 33.2652 20.1666 33 20.1666H26V18.8191C26 18.576 25.8946 18.3429 25.7071 18.171C25.5196 17.999 25.2652 17.9025 25 17.9025C24.7348 17.9025 24.4804 17.999 24.2929 18.171C24.1054 18.3429 24 18.576 24 18.8191V20.1666H22V16.885C20.3008 16.6301 18.5818 16.5013 16.86 16.5C13.0628 16.4852 9.30815 17.233 5.86 18.6908C5.29249 18.9363 4.81371 19.3259 4.48048 19.8133C4.14725 20.3008 3.97355 20.8656 3.98 21.4408V27.5H15ZM32 29.3333H17V22H24V22.385C24 22.6281 24.1054 22.8612 24.2929 23.0332C24.4804 23.2051 24.7348 23.3016 25 23.3016C25.2652 23.3016 25.5196 23.2051 25.7071 23.0332C25.8946 22.8612 26 22.6281 26 22.385V22H32V29.3333Z"
      fill="black"
      :class="containerClass"
    />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type:  [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
